import styled, { StyledComponent } from 'styled-components'
import Content, { ContentProps } from './Content'
import Button from './Button'
import Controls from './Controls'
import Heading, { HeadingProps } from './Heading'
import Title from './Title'
import {
  Toggle,
  ToogleGroup,
  ToggleItem,
  ToggleLabel,
  ToggleProps,
  ToggleText,
  ToggleWrapper,
} from './Toggle'

const Expandable = styled.div`
  padding-bottom: 12px;
  display: flex;
  flex-direction: column;
` as Expandable

Expandable.Button = Button
Expandable.Content = Content
Expandable.Controls = Controls
Expandable.Heading = Heading
Expandable.Title = Title
Expandable.Toggle = Toggle
Expandable.ToggleGroup = ToogleGroup
Expandable.ToggleItem = ToggleItem
Expandable.ToggleText = ToggleText
Expandable.ToggleLabel = ToggleLabel
Expandable.ToggleWrapper = ToggleWrapper

export default Expandable

type Expandable = StyledComponent<'div', any> & {
  Button: StyledComponent<'div', any>
  Content: StyledComponent<'div', any, ContentProps>
  Controls: StyledComponent<'div', any>
  Heading: StyledComponent<'div', any, HeadingProps>
  Title: StyledComponent<'div', any>
  Toggle: StyledComponent<'input', any, ToggleProps>
  ToggleGroup: StyledComponent<'div', any>
  ToggleItem: StyledComponent<'div', any>
  ToggleLabel: StyledComponent<'label', any>
  ToggleText: StyledComponent<'span', any>
  ToggleWrapper: StyledComponent<'div', any>
}
